import React from 'react';
import { Button, Divider, Form, Input, Modal, Select } from 'antd';
import { axius, func } from 'helpers';
import PayKYC from './PayKYC';


const BuyTicket = (props) => {

    const [form] = Form.useForm();

    const { visible, event, isForeign, _data: { kyc } } = props;

    const [step, setStep] = React.useState(1);
    const [payWith, setPayWith] = React.useState('');
    const [peyWith, setPeyWith] = React.useState('');
    const [tickets, setTickets] = React.useState(0);
    const [myTicket, setMyTicket] = React.useState({});
    const [submitting, setSubmitting] = React.useState(false);
    const [errMessage, setErrMessage] = React.useState('');

    const close = () => {
        setStep(1);
        setMyTicket({});
        props.onCancel();
        form.resetFields();
    }

    const submit = (v) => {
        let amount = v.tickets * myTicket.price;
        if (step > 1) {
            v = {
                ...v,
                pay_with: func.payWith(v.pay_with),
                data: {
                    event: event.uuid,
                    ticket: myTicket,
                    quantity: v.tickets,
                },
                type: 'ticket',
                amount,
                customer: v.person,
                description: `Ticket purchase: ${myTicket.name} - ${v.tickets}x ${event.country.currency} ${func.numberFormat(myTicket.price)}`,
                country: isForeign.country,
            };
            setErrMessage('');
            setSubmitting(true);
            axius.post('payments', v).then(res => {
                if (res.status === 200) {
                    if (res.data?.checkout_url) {
                        window.location = res.data.checkout_url;
                    } else {
                        setStep(3);
                        setSubmitting(false);
                    }
                } else {
                    setSubmitting(false);
                    setErrMessage(res.status === 412 ? res.data.join('<br />') : res.message);
                }
            });
        } else {
            let pw = func.payWith(v.pay_with);
            if (pw) {
                setPayWith(pw);
                pw = pw.split(':');
                // let cc = isForeign.isForeign ? event.country.code : isForeign.country;
                // let fee = fees[cc][pw[0]].receive[(pw[1] || 'momo')];
                // fee = fee.foreign ? (fee[isForeign.forex.rate !== 1 ? 'foreign' : 'local']) : fee.local;
                setStep(2);
                setErrMessage('');
            } else {
                setErrMessage(func.intl('Alert.NoPayWith', `Sorry, We have no partner enabled for this payment method`));
            }
        }
    }

    const pw = payWith.split(':');
    const KYC = kyc[`${pw[0]}:${pw[1]}`] || [];
    const paymentMethods = props._data.paymentMethods[event.country.code];

    const pwForeign = !!(peyWith.split('_')[1] === 'foreign');
    const currency = pwForeign ? isForeign.currency : event.country.currency;
    const decimal = currency !== 'XOF' ? 2 : 0;
    const forexRate = pwForeign ? isForeign.forex.rate : 1;

    return (
        <React.Fragment>
            <Modal open={visible} title={event.name} width={450} centered footer={null} maskClosable={false} destroyOnClose={true} onCancel={close}>
                <Form form={form} layout="vertical" onFinish={submit}>

                    {errMessage && (
                        <div className="alert alert-danger text-center p-2 small" dangerouslySetInnerHTML={{ __html: errMessage }} />
                    )}

                    {/* s t e p  1 */}
                    <div className={`${step !== 1 ? 'hide' : ''}`}>
                        {myTicket.uuid && (
                            <div className="mb-3">
                                <span className="p-2 bg-gray-50 rounded-full cursor-pointer hover:bg-gray-100" onClick={() => setMyTicket({})}>
                                    &nbsp;<i className="fa fa-chevron-left" /> All tickets&nbsp;
                                </span>
                            </div>
                        )}
                        
                        {event.tickets.sort((a, b) => func.sortString(a, b, 'price')).filter(t => (t.quantity > +(t.sales || 0) && (!myTicket.uuid || t.uuid === myTicket.uuid))).map(ticket => (
                            <div
                                key={ticket.uuid}
                                onClick={() => setMyTicket(ticket)}
                                className={`border-2 border-gray-200 rounded-md p-3 hover:bg-gray-100 cursor-pointer mb-2`}
                            >
                                <div className="border-b pb-2 mb-2 font-medium">
                                    {ticket.name}
                                </div>
                                <div className="font-semibold text-xl">
                                    {myTicket.uuid === ticket.uuid && (<i className="fa fa-check-circle text-success mr-1" />)}
                                    {event.country.currency} {func.numberFormat(ticket.price, 2)}
                                </div>
                                <div className="text-gray-500 text-xs mt-1" dangerouslySetInnerHTML={{ __html: ticket.description.split('\n').join('<br />') }} />
                                <div className="text-gray-500 text-xs mt-1">{func.numberFormat(ticket.quantity - +(ticket.sales || 0))} ticket(s) left</div>
                            </div>
                        ))}

                        {myTicket.uuid && (
                            <div className="mt-4">
                                <Form.Item
                                    name="pay_with" label={func.intl('Label.PaymentMethod', 'Payment method')}
                                    rules={[{ required: step === 1, message: func.intl('Alert.Required', 'This field is required!'), },]}
                                >
                                    <Select
                                        size="large" autoComplete="off" placeholder="Choose an option" disabled={submitting}
                                        onChange={e => setPeyWith(e)}
                                    >
                                        {paymentMethods.map((option, i) => (
                                            option.value === 'break' ?
                                                <Select.Option key={i} disabled={true}>::::: {option.label} </Select.Option> :
                                                <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="tickets"
                                    label={(<span>{func.intl('Label.Tickets', 'Number of tickets')}</span>)}
                                    rules={[{ required: step === 1, message: func.intl('Alert.Required', 'This field is required!'), },]}
                                >
                                    <Input
                                        type="number" size="large" autoComplete="off"
                                        placeholder={func.intl('Label.Tickets', 'Number of tickets')}
                                        onChange={e => setTickets(+e.target.value)}
                                        disabled={submitting}
                                    />
                                </Form.Item>

                                {tickets > 0 && (
                                    <div className="alert alert-info text-center mt-30s p-10">
                                        {func.intl('Text.YouPay', 'You will pay')}: <br />
                                        <span>
                                            <div style={{ fontSize: 20, fontWeight: 800 }}>
                                                {currency} {func.numberFormat(myTicket.price * tickets * forexRate, decimal)}
                                            </div>
                                            {isForeign.isForeign ? <div className="text-muted" style={{ fontSize: 12 }}>({func.intl('Text.EstimatedAmount', 'estimated amount')})</div> : ''}
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* s t e p  2 */}
                    <div className={`${step !== 2 ? 'hide' : ''}`}>
                        <PayKYC {...props} form={form} kyc={KYC} step={step} submitting={submitting} />
                    </div>

                    {/* s t e p  3 */}
                    <div className={`${step !== 3 ? 'hide' : ''}`}>
                        <PayKYC {...props} form={form} kyc={['code']} step={step} submitting={submitting} />
                    </div>

                    {myTicket.uuid && (
                        <div>
                            <Divider />
                            <div className="row mt-4">
                                <div className="col-5">
                                    {step > 1 && (
                                        <Button shape="round" size="large" block type="dark" htmlType="button" onClick={() => setStep(st => (st - 1))} disabled={submitting}>
                                            {func.intl('Button.Previous', 'Previous')}
                                        </Button>
                                    )}
                                </div>
                                <div className="col-7">
                                    <Button shape="round" size="large" block type="primary" htmlType="submit" loading={submitting}>
                                        {step === 3 ? func.intl('Button.MakePayment', 'Make payment') : func.intl('Button.Next', 'Next')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Form>
            </Modal>
        </React.Fragment>
    );
}

export default BuyTicket;